import React from 'react';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';

export const OnlineIndicator = observer(({ user, includeUser = true }) => {
  const {
    MessageStore: { onlineChatBidders },
  } = useStores();

  const offlineColor = '#f00';
  const onlineColor = '#00af00';

  const isOffline =
    onlineChatBidders.filter((bidder) => bidder === user)?.length === 0;

  return isOffline ? (
    <CircleIndicator
      title="OFFLINE"
      color={offlineColor}
      user={user}
      includeUser={includeUser}
    />
  ) : (
    <CircleIndicator
      title="ONLINE"
      color={onlineColor}
      user={user}
      includeUser={includeUser}
    />
  );

  // return isOffline ? (
  //   <OfflineTextIndicator color={offlineColor} user={user} text="OFFLINE" />
  // ) : (
  //   user
  // );

  // return isOffline ? (
  //   <TextIndicator title="OFFLINE" color={offlineColor} user={user} />
  // ) : (
  //   <TextIndicator title="ONLINE" color={onlineColor} user={user} />
  // );
});

export default OnlineIndicator;

export const OfflineTextIndicator = ({ color, text, user }) => (
  <>
    {user}
    <em style={{ fontSize: '.6em', color, paddingLeft: '3px' }}>{text}</em>
  </>
);

export const TextIndicator = ({ title, color, user }) => (
  <span
    title={title}
    style={{
      color,
    }}
  >
    {user}
  </span>
);

export const CircleIndicator = ({ title, color, user, includeUser }) => {
  return includeUser ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <span
        title={title}
        style={{
          display: 'inline-block',
          fontSize: '.5em',
          minWidth: '10px',
          width: '10px',
          minHeight: '10px',
          height: '10px',
          borderRadius: '50%',
          background: color,
          marginRight: '3px',
          marginTop: '10px',
        }}
      />
      <span style={{ textAlign: 'left' }}>{user}</span>
    </div>
  ) : (
    <span
      title={title}
      style={{
        display: 'inline-block',
        fontSize: '.5em',
        minWidth: '10px',
        width: '10px',
        minHeight: '10px',
        height: '10px',
        borderRadius: '50%',
        background: color,
        marginRight: '3px',
      }}
    />
  );
};
